module.exports = __webpack_public_path__ + "img/album21_02.679c2f6b.jpg";